/**
 * @file Zoom de la camera du hub : + / - / RAZ (remplace Deplacement auto / Tir auto dans ce mode).
 */
import { Component } from '../core/Component';
import { h } from '../core/dom';
import { uiIcon } from '../core/uiIcons';
import type { UiIconId } from '../core/uiIcons';
import { send } from '../core/feedback';
import type { UiContext } from '../UiContext';

export class ZoomControls extends Component {
  constructor(ctx: UiContext) {
    super(ctx, 'div', 'zoom-controls');
  }

  protected build(): void {
    const { i18n } = this.ctx;
    const defs: Array<{ action: 'in' | 'out' | 'reset'; icon: UiIconId; label: string }> = [
      { action: 'in', icon: 'zoomIn', label: i18n.t('hub.zoomIn') },
      { action: 'out', icon: 'zoomOut', label: i18n.t('hub.zoomOut') },
      { action: 'reset', icon: 'reset', label: i18n.t('hub.zoomReset') },
    ];
    for (const d of defs) {
      this.el.append(
        h(
          'button',
          { class: `toggle zoom-${d.action}`, type: 'button', 'aria-label': d.label, 'data-ui-block': true, 'data-fast': true, onclick: () => void send(this.ctx, { type: 'hub.zoom', action: d.action }) },
          h('span', { class: 'toggle-icon' }, uiIcon(d.icon)),
          h('span', { class: 'toggle-label' }, d.label),
        ),
      );
    }
  }
}
